import axios from '@/axios'

const API_BASE = `${process.env.VUE_APP_API_BASE_URL}/api/alquileres`
const ENDPOINTS = {
  myRent: `${API_BASE}/contratos/mi-alquiler/`,
}

const state = {
  loading: false,
  error: null,
  contract: null,
  vinculacion: null,
  invoices: [],
  payments: [],
  adjustments: [],
  penalties: [],
  projection: null,
}

const mutations = {
  SET_LOADING(state, val) { state.loading = val },
  SET_ERROR(state, err) { state.error = err },
  SET_CONTRACT(state, payload) { state.contract = payload },
  SET_VINCULACION(state, payload) { state.vinculacion = payload },
  SET_INVOICES(state, payload) { state.invoices = payload || [] },
  SET_PAYMENTS(state, payload) { state.payments = payload || [] },
  SET_ADJUSTMENTS(state, payload) { state.adjustments = payload || [] },
  SET_PENALTIES(state, payload) { state.penalties = payload || [] },
  SET_PROJECTION(state, payload) { state.projection = payload },
}

const actions = {
  async fetchMyRental({ commit }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const { data } = await axios.get(ENDPOINTS.myRent, { withCredentials: true })

      if (data.vinculacion) {
        commit('SET_VINCULACION', data.vinculacion)
      } else {
        commit('SET_VINCULACION', null)
      }

      if (data.contract) {
        const c = data.contract
        commit('SET_CONTRACT', {
          id: c.id,
          cliente_email: c.cliente_email,
          cliente_nombre: c.cliente_nombre,
          fecha_inicio: c.fecha_inicio,
          fecha_fin: c.fecha_fin,
          monto_base: c.monto_base,
          moneda: c.moneda,
          dia_vencimiento: c.dia_vencimiento,
          aplicar_mora: c.aplicar_mora,
          porcentaje_mora_mensual: c.porcentaje_mora_mensual,
          esquema_ajuste: c.esquema_ajuste,
          indice_referencia: c.indice_referencia,
          periodicidad_ajuste_meses: c.periodicidad_ajuste_meses,
          estado: c.estado,
          resumen: c.resumen,
          propiedad: c.propiedad,
        })
        commit('SET_INVOICES', c.facturas || [])
        commit('SET_PAYMENTS', c.pagos || [])
        commit('SET_ADJUSTMENTS', c.ajustes || [])
        commit('SET_PENALTIES', c.penalidades || [])
      } else {
        commit('SET_CONTRACT', null)
        commit('SET_INVOICES', [])
        commit('SET_PAYMENTS', [])
        commit('SET_ADJUSTMENTS', [])
        commit('SET_PENALTIES', [])
      }
    } catch (err) {
      if (err?.response?.status === 404) {
        commit('SET_CONTRACT', null)
        commit('SET_VINCULACION', null)
        commit('SET_INVOICES', [])
        commit('SET_PAYMENTS', [])
        commit('SET_ADJUSTMENTS', [])
        commit('SET_PENALTIES', [])
        commit('SET_ERROR', null)
      } else {
        commit('SET_ERROR', err.response?.data || err.message || 'Error cargando datos de alquiler')
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async aceptarVinculacion({ commit }, contractId) {
    const { data } = await axios.post(
      `${API_BASE}/contratos/${contractId}/aceptar-vinculacion/`,
      {},
      { withCredentials: true }
    )
    commit('SET_VINCULACION', data)
    // Recargar para obtener el contrato completo
    await this.dispatch('rent/fetchMyRental')
  },

  async rechazarVinculacion({ commit }, contractId) {
    const { data } = await axios.post(
      `${API_BASE}/contratos/${contractId}/rechazar-vinculacion/`,
      {},
      { withCredentials: true }
    )
    commit('SET_VINCULACION', data)
  },

  async recalcInvoiceLateFees(_, invoiceId) {
    return axios.post(`${API_BASE}/facturas/${invoiceId}/recalcular-mora/`, {}, { withCredentials: true })
  },
  async confirmPayment(_, paymentId) {
    return axios.post(`${API_BASE}/pagos/${paymentId}/confirmar/`, {}, { withCredentials: true })
  },
  async generateInvoice({ state, dispatch }) {
    if (!state.contract?.id) throw new Error('Contrato no disponible')
    await axios.post(`${API_BASE}/contratos/${state.contract.id}/generar-factura/`, {}, { withCredentials: true })
    await dispatch('fetchMyRental')
  },
  async fetchProjection({ state, commit }) {
    if (!state.contract?.id) throw new Error('Contrato no disponible')
    const { data } = await axios.get(`${API_BASE}/contratos/${state.contract.id}/proyeccion/`, { withCredentials: true })
    commit('SET_PROJECTION', data)
  },
}

const getters = {
  myContract: s => s.contract,
  myVinculacion: s => s.vinculacion,
  vinculacionStatus: s => s.vinculacion?.status || null,
  myInvoices: s => s.invoices,
  myPayments: s => s.payments,
  myAdjustments: s => s.adjustments,
  myPenalties: s => s.penalties,
  myProjection: s => s.projection,
  rentLoading: s => s.loading,
  rentError: s => s.error,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
